<nb-card class="edit-dialog">
    <nb-card-header>
        <p class="primary-header">{{ title }}</p>
        <button ghost status="basic" nbButton (click)="close()">
            <nb-icon icon="close" status="basic"></nb-icon>
        </button>
    </nb-card-header>

    <nb-card-body>
        <ngx-alert-message-inline
            *ngIf="alertMessage"
            [message]="alertMessage"
            [variant]="alertStatus"
        ></ngx-alert-message-inline>

        <form [formGroup]="form">
            <label *ngIf="label" for="comment">{{ label }}</label>
            <textarea
                formControlName="comment"
                fullWidth
                id="comment"
                nbInput
                placeholder="Comment"
                ngxTrimInput
            ></textarea>
            <ngx-input-error [formGroup]="form" fieldName="comment"></ngx-input-error>
        </form>

        <p class="label mt-2" *ngIf="message">{{ message }}</p>

        <div class="btn-container">
            <button (click)="close()" nbButton status="basic" fullWidth>
                <nb-icon icon="close-circle-outline"></nb-icon>
                {{ cancelText }}
            </button>

            <button
                class="ml-3"
                fullWidth
                (click)="save()"
                nbButton
                status="primary"
                [disabled]="form.invalid && firstSaveFormTrigger"
            >
                <nb-icon [icon]="confirmIcon"></nb-icon>
                {{ confirmText }}
            </button>
        </div>
    </nb-card-body>
</nb-card>
